import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {MGiftVoucherPriceCategoryComponent} from './view/master-files/m-gift-voucher-price-category/m-gift-voucher-price-category.component';
import {MGiftVoucherComponent} from './view/master-files/m-gift-voucher/m-gift-voucher.component';
import {TGiftVoucherTransferComponent} from './view/transactions/t-gift-voucher-transfer/t-gift-voucher-transfer.component';
import {MGiftVoucherBulkCustomerComponent} from './view/master-files/m-gift-voucher-bulk-customer/m-gift-voucher-bulk-customer.component';
import {MStoreComponent} from './view/master-files/m-store/m-store.component';
import {MSupplierComponent} from './view/master-files/m-supplier/m-supplier.component';
import {TGrnComponent} from './view/transactions/t-grn/t-grn.component';
import {TStockTransferInApproveComponent} from './view/transactions/t-stock-transfer-in-approve/t-stock-transfer-in-approve.component';
import {TStockTransferOutComponent} from './view/transactions/t-stock-transfer-out/t-stock-transfer-out.component';
import {TransactionSummaryDashboardComponent} from './view/dashboard/transaction-summary-dashboard/transaction-summary-dashboard.component';

const routes: Routes = [
  {
    path: 'gift-voucher-price-category',
    component: MGiftVoucherPriceCategoryComponent
  },
  {
    path: 'gift-voucher',
    component: MGiftVoucherComponent
  },
  {
    path: 'gift-voucher-bulk-customer',
    component: MGiftVoucherBulkCustomerComponent
  },
  {
    path: 'gift-voucher-transfer',
    component: TGiftVoucherTransferComponent
  },
  {
    path: 't-stock-transfer-approve',
    component: TStockTransferInApproveComponent
  },
  {
    path: 't-stock-transfer-out',
    component: TStockTransferOutComponent
  },
  {
    path: 't-grn',
    component: TGrnComponent
  },
  {
    path: 'm-store',
    component: MStoreComponent
  },
  {
    path: 'm-supplier',
    component: MSupplierComponent
  },
  {
    path: 'd-transaction-summary-dashboard',
    component: TransactionSummaryDashboardComponent
  },
  {
    path: '',
    redirectTo: '/gift-voucher-price-category',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/gift-voucher-price-category',
    pathMatch: 'full'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  declarations: []
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts